


















































































import settings from '@/settings'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import m from '@/graphql/mutation'
import af from '@/utils/authorized_formats'

export default {
    name: 'users_vouchers'

    props: {
        uid: {
            type: String
        }
    }

    data: ()->
        dialog_visible: false
        errors: {}
        loading: true
        alert: false
        search: ''
        pager_count: 5
        current_page: 1
        page_size: 10
        active_names: [1]
        false: false
        max_filesize: af['user_voucher']['file']['max_filesize']/1024/1024
        authorized_formats: af['user_voucher']['file']['authorized_formats']
        voucher: {
            uid: ''
            user_uid: @uid
            name: ''
            file_data: ''
            file_name: ''
        }
        vouchers: []

    computed:
        data_filtered: ()->
            self = @
            data = @vouchers.filter (x) ->
                !self.search || x.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.name.toLowerCase().includes(self.search.toLowerCase())\
                || x.modified.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.modified.toLowerCase().includes(self.search.toLowerCase())
            return data

        data_paged: ()->
            data = @data_filtered.slice(((@current_page - 1) * @page_size), (@page_size * @current_page))
            return data

        toggle_collapse_text: ()->
            text = "Ajouter une pièce justificative"
            if @active_names.length > 1
                text = "Fermer"
            return text

        toggle_collapse_icon: ()->
            class_icon = 'mdi-plus-circle-o'
            if @active_names.length > 1
                class_icon = 'mdi-close-circle-o'
            return class_icon

        has_mutation_right: ()->
            return @has_access_right(@get_access('edit'))

        has_deletion_right: ()->
            return @has_access_right(@get_access('delete'))

    methods:
        has_access_right: t.has_access_right

        listen_sort: ({ column, prop, order })->
            # console.log "LISTEN", column, prop, order
            self = @
            @vouchers.sort (a,b)->
                modifier = 1
                if order == 'descending'
                    modifier = -1
                return a[prop].toLowerCase().localeCompare(b[prop].toLowerCase())*modifier

        handle_size_change: (val)->
            @page_size = val

        handle_current_change: (val)->
            @current_page = val

        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        collapse_change: (value)->
            # console.log "VUE TOGGLE ", value
            @errors = {}
            @voucher.uid = ''
            @voucher.name = ''
            @$refs.voucher_upload.clearFiles()
            return

        handle_file_remove: (file, fileList)->
            @$refs.voucher_upload.clearFiles()
            @voucher.file_data = ''
            @voucher.file_name = ''
            return

        handle_file_change: (file, fileList)->
            is_good_ext = file.raw.type in af['user_voucher']['file']['mime_types']
            is_good_size = file.size < af['user_voucher']['file']['max_filesize']

            if !is_good_ext
                n.file_error('Erreur', 'Le fichier doit être de type '+@authorized_formats+'.')
                fileList.pop()
                return
            if !is_good_size
                n.file_error('Erreur', 'Le fichier ne peut pas excéder '+@max_filesize+'Mo.')
                fileList.pop()
                return

            self = @
            if fileList.length > 1
                fileList.splice(0,1)
            reader = new FileReader()
            reader.onload = (e)->
                # console.log 'E', e
                self.voucher.file_data = e.target.result
                self.voucher.file_name = file.name
            reader.readAsDataURL(file.raw)
            # console.log "FILE", @voucher
            return

        download_file: (voucher)->
            url = settings.media_url+voucher.file_dir+'/'+voucher.file
            filename = voucher.complete_filename
            t.download_file(url, filename)
            return

        edit_voucher: (voucher)->
            @active_names = [1]
            @voucher.uid = voucher.uid
            @voucher.name = voucher.name
            @dialog_visible = true
            @errors = {}
            return

        get_access: (suffix)->
            access = "user_vouchers_self_"+suffix
            if @$route.name == 'company_users_vouchers'
                access = "user_vouchers_"+suffix
            return access

        delete_voucher: (voucher_uid)->
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir supprimer cette pièce justificative ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    m.run('delete_object', ['user_voucher', voucher_uid])
                    .then (resp)->
                        # console.log "DELETE VOUCHER THEN THEN ", resp
                        if resp.body.data.user_voucher_deletion.ok
                            n.success()
                            self.get_vouchers()
                        else
                            n.gql_error("users_vouchers: delete_voucher: then", resp.body.data.user_voucher_deletion.message)
                    .catch (resp)->
                        n.catch_error(resp, "users_vouchers: delete_voucher()")
                .catch (cancel)->
                    return

        save: ()->
            self = @
            if @voucher.uid == '' and @voucher.file_name == ""
                n.file_error('Erreur', 'Un fichier est requis')
                return
            m.run('save_voucher', [@voucher])
            .then (resp)->
                if resp.body.data.user_voucher_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.user_voucher_form_mutation.errors.length > 0
                    self.errors = resp.body.data.user_voucher_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    self.errors = {}
                    n.success()
                    self.voucher = {
                        uid: ''
                        user_uid: self.uid
                        name: ''
                        file_data: ''
                        file_name: ''
                    }
                    self.dialog_visible = false
                    self.$refs.voucher_upload.clearFiles()
                    self.active_names = [1]
                    self.get_vouchers()
            .catch (resp)->
                n.catch_error(resp, "users_vouchers: save()")

        get_vouchers: ()->
            self = @
            @loading = true
            q.run('get_voucher_set', [@uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("users_vouchers: get_vouchers: then", e.message)
                else
                    # console.log "GET VOUCHERS : ", resp.body.data.voucher_set
                    self.vouchers = resp.body.data.voucher_set
                    self.loading = false
                    if self.vouchers.length == 0
                        self.alert = true
                    else
                        self.alert = false
            .catch (resp)->
                n.catch_error(resp, "users_vouchers: get_vouchers()")
            
    beforeMount: ()->
        if @uid != '0'
            @get_vouchers()
}
